import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'
import { Button, makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import Tooltip from '../../atoms/Tooltip'
import SydModal from '../../commonDesign/SydModal'
import AbundanceEngineSubView from '../../../abundanceEngine/AbundanceEngineSubView'

const useStyles = makeStyles(() => ({
  button: {
    borderRadius: 'var(--border-radius-2xl)',
    border: 'var(--border-neutral-normal)',
    backgroundColor: '#FFF',
    textTransform: 'none',
    padding: '0.5rem 1rem',
    '& > span': {
      fontSize: '0.75rem',
      lineHeight: '0.75rem',
      color: '#212945',
      fontWeight: 'bold'
    }
  }
}))

function OverlayLink ({ to, tooltipTitle, modalTitle, children, variant }) {
  const classes = useStyles()
  const location = useLocation()
  const [open, setOpen] = useState(false)

  const handleClick = useCallback((e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return
    e.preventDefault()
    setOpen(true)
  }, [])

  const handleClose = useCallback(() => setOpen(false), [])

  const resolvedTitle = modalTitle ?? tooltipTitle ?? 'Details'

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <Button
          size='small'
          to={{
            pathname: to,
            search: location.search
          }}
          component={Link}
          onClick={handleClick}
          className={clsx({
            [classes.button]: variant === 'button'
          })}
        >
          {children}
        </Button>
      </Tooltip>
      <SydModal
        open={open}
        onClose={handleClose}
        size='xmedium'
        title={resolvedTitle}
      >
        <AbundanceEngineSubView viewPath={to} />
      </SydModal>
    </>
  )
}

OverlayLink.displayName = 'OverlayLink'

OverlayLink.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string,
  tooltipTitle: PropTypes.string,
  modalTitle: PropTypes.string,
  variant: PropTypes.oneOf(['button', 'link'])
}

OverlayLink.defaultProps = {
  to: '/',
  tooltipTitle: undefined,
  modalTitle: undefined,
  variant: 'button'
}

export default OverlayLink
